/*
 * Cyber Tole — atributo de carrito "Regalo Cyber: Sí".
 * Lo agrega cuando el carrito llega al umbral del regalo y lo quita si baja,
 * para que bodega lo vea en el pedido (Detalles adicionales).
 * Datos: el bloque [data-pt-cyber-gift] de snippets/snippet-shipping-bar.liquid.
 * Solo llama a /cart/update.js; no publica eventos ni vuelve a pintar el
 * carrito, así que no puede generar bucles de refresco del drawer.
 */
(function () {
  if (window.ptCyberCartInit) return;
  window.ptCyberCartInit = true;

  var KEY = 'Regalo Cyber';
  var VALUE = 'Sí';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var timer = null;
  var running = false;

  function config() {
    var el = document.querySelector('[data-pt-cyber-gift]');
    if (!el) return null;
    var end = parseInt(el.dataset.ptEnd, 10) || 0;
    return {
      active: el.dataset.ptActive === 'true' && (!end || Date.now() < end),
      threshold: parseInt(el.dataset.ptGiftThreshold, 10) || 0,
    };
  }

  function update(want) {
    var attributes = {};
    attributes[KEY] = want ? VALUE : '';
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    });
  }

  function syncFromServer() {
    if (running) return;
    running = true;
    fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var cfg = config();
        var has = !!(cart.attributes && cart.attributes[KEY] === VALUE);
        var want = !!(cfg && cfg.active && cart.item_count > 0 && cart.total_price >= cfg.threshold);
        if (!cfg && !has) return;
        if (want !== has) return update(want);
      })
      .catch(function () {})
      .then(function () {
        running = false;
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(syncFromServer, 400);
  }

  function onLoad() {
    var el = document.querySelector('[data-pt-cyber-gift]');
    if (el && el.dataset.ptGiftWant !== el.dataset.ptGiftHas) schedule();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onLoad);
  } else {
    onLoad();
  }
})();
